import { render, staticRenderFns } from "./consent-view.vue?vue&type=template&id=a7c577da&"
import script from "./consent-view?vue&type=script&lang=js&"
export * from "./consent-view?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports